<script type="text/jsx">
import { toUpper } from 'lodash'
import AddonNewIcon from '@/assets/plans/addon_new.svg';
import Tile from '@/components/tile.vue';
import { isEduSchCmpPlusContext, ZOOM_MEETING_SUB_TYPES } from '@/plans/ZOOM_MEETING/common/utils';

export default {
  components: {
    Tile,
  },
  props: {
    isSuccessPage: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      logo: '',
      title: '',
      subtitle: '',
      description: '',
      addText: this.$t('billing.common.add'),
      addonNewIcon: AddonNewIcon,
      isNewAddOn: false,
      headMarginRight: '200px',
      isFreeTrial: false,
      freeTrialDays: 0
    };
  },
  watch: {
    isFreeTrial(val) {
      if (val) {
        if (!this.promo) {
          this.promo = toUpper(this.$t('billing.trial.free_trial'))
        }
        this.addText = this.$t('billing.trial.try_for_n_days', [this.freeTrialDays])
      } else {
        this.promo = ''
        this.addText = this.$t('billing.common.add')
      }
      this.$nextTick(() => {
        this.setHeadMarginRight()
      })
    }
  },
  methods: {
    addOn() {
      // addPlanFromEnterKey For A11Y requirement
      // target is BUTTON comes from keyboard enter, will auto focaus on the first option in config card
      // target is SPAN comes from click
      document.addPlanFromEnterKey = true;
      this.$emit('add', this.$options?.key);

      if (isEduSchCmpPlusContext || (window?.$config('plan') === ZOOM_MEETING_SUB_TYPES.ZONE_EDU_SCH_CMP)) {
        this.$tracking.buyInteraction(`zoom one for education school and campus${isEduSchCmpPlusContext ? ' plus' : ''} add-ons`, `${this.title?.toLowerCase()} - add`);
      } else {
        this.$tracking.addOnBuyInteraction('add-ons', `${this.title?.toLowerCase()} - add`);
      }
    },
    add2cart() {
      this.$emit('add', this.$options?.key);
    },
    addFreeTrial() {
      this.addOn()
    },
    mx_logo() {
      if (!this.logo) return;
      return <div class="opc-addon__logo">
        <img src={this.logo} class="plan-icon plan-icon__default" alt={`${this.title} Icon`} tabindex="-1" />
      </div>;
    },
    mx_title() {
      return <h3 class="opc-addon__title text-capitalize">
        {this.promo && this.$context.is.mobile ? <p><span class={['opc-addon__title__promo', {'opc-addon__promo-freetrial': this.isFreeTrial}]}>{this.promo}</span><br /></p> : null}
        {this.title}
        {this.isNewAddOn ? <img src={this.addonNewIcon} alt="New" class="opc-addon__new-flag" /> : null}
        {this.promo && !this.$context.is.mobile? <span class={['opc-addon__title__promo', {'opc-addon__promo-freetrial': this.isFreeTrial}]}>{this.promo}</span> : null}
      </h3>;
    },
    mx_subTitle() {
      return <div class="opc-addon__subtitle">
        {this.subtitle}
        <priceVATTip />
      </div>;
    },
    mx_titleBox() {
      return <div class="opc-addon__title-box">
        {this.mx_title()}
        {this.mx_subTitle()}
      </div>;
    },
    mx_action() {
      let ariaLabel = ''
      if (this.isNewAddOn) {
        ariaLabel = `Add ${this.title} ${this.promo??''} New`
      } else if (this.isFreeTrial) {
        ariaLabel = `Try ${this.title} for ${this.freeTrialDays} days`
      } else {
        ariaLabel = `Add ${this.title} ${this.promo??''}`
      }
      return <div class="opc-addon__action">
        <zm-button
          ref="addBtn"
          ghost
          round
          aria-label={ariaLabel}
          class="text-capitalize"
          size="small"
          type="primary"
          onClick={this.isSuccessPage ? this.add2cart : (this.isFreeTrial ? this.addFreeTrial : this.addOn)}>
          {this.addText}
        </zm-button>
        {this.isFreeTrial &&
          <div class="opc-addon__action-sub">
            <zm-button type="link" onClick={this.addOn} aria-label={`or buy ${this.title} now`}>
              {this.$t('billing.trial.or_buy_now')}
            </zm-button>
          </div>
        }
      </div>;
    },
    mx_head() {
      return <div class="opc-addon__main">
        <div class="opc-addon__head" style={{marginRight: this.headMarginRight}}>
          {this.mx_logo()}
          {this.mx_titleBox()}
        </div>
        {this.mx_desc()}
      </div>;
    },
    mx_desc() {
      return <div class={["opc-addon__description", "first-capitalize", this.isFreeTrial ? 'opc-addon__description-freetrial' : '']}>
        {this.description}
      </div>;
    },
    isVisible(element) {
      return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
    },
    setHeadMarginRight() {
      const addBtn = this.$refs.addBtn?.$el
      if (addBtn) {
        this.headMarginRight = addBtn.offsetWidth + 'px'
      }
    }
  },
  render() {
    const uniqueClass = `opc-addon--${this.planType}`;
    const classList = ['opc-addon', uniqueClass, this.logo ? 'has-logo' : '', this.isFreeTrial ? 'opc-addon__free-trial' : ''];

    return <tile class={classList}>
      <div class="opc-addon__container">
        {this.mx_head()}
        {this.mx_action()}
      </div>
    </tile>
  },
  mounted() {
    this.setHeadMarginRight()

    // [ZTSPZ-306][AB-ECOMM] 2024.5 - OPC Confirmation Page - Addons
    // Influenced by Optimizely campaigns
    if (this.$config('isNewSuccessPage') && this.$context.is.mobile) {
      let index = 0;
      let timer = setInterval(() => {
        try {
          if (index >= 10) {
            clearInterval(timer);
          }
          index++;
          const isVisible = this.isVisible(this.$refs.addBtn.$el);
          if (isVisible) {
            this.setHeadMarginRight()
            clearInterval(timer);
          }
        } catch {
          clearInterval(timer);
        }
      }, 20);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/_variables.scss';
@import '@zoom/billing-responsive/styles/responsive.scss';
@import '@/styles/scss-utils.scss';

$logo-width: 44px;
$logo-width-mobile: 32px;
$gap: 16px;
.opc-addon {
  .plan-icon {
    &__default {
      width: $logo-width;
      height: $logo-width;
      @include media(mobile, tablet) {
        width: $logo-width-mobile;
        height: $logo-width-mobile;
      }
    }
  }

  &__container {
    position: relative;
    width: 100%;
    height: 100%;
  }

  &__main {
    display: flex;
    flex-direction: column;
  }

  &__head {
    display: flex;
  }
  &__logo {
    flex-shrink: 0;
    width: $logo-width;
    height: $logo-width;
    font-size: 0;
    margin-right: $gap;
    @include media(mobile, tablet) {
      margin-right: 8px;
      width: $logo-width-mobile;
      height: $logo-width-mobile;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  &__title-box {
    flex: 1;
  }
  &__title {
    font-weight: 700;
    font-size: 20px;
    line-height: 150%;
    color: #00053d;
    @include media(mobile,tablet){
      font-size: 16px;
    }
    &__promo{
      color: white;
      white-space: nowrap;
      font-size: 14px;
      padding: 2px 4px;
      margin-left: 8px;
      font-weight: normal;
      vertical-align: middle;
      border-radius: 100px;
      background: linear-gradient(78deg, #493AB7 0%, #CF4B0A 100%);
      @include media(mobile,tablet){
        border-radius: 100px;
        font-size: 14px;
        padding: 2px 4px;
      }
      @include media(mobile){
        margin-left: 0px;
      }
      &.opc-addon__promo-freetrial {
        background: linear-gradient(78deg, #493ab7 0%, #925dff 100%)
      }
    }
  }
  &__new-flag {
    display: inline-block;
    vertical-align: -0.2em; // Base on design, it's not completely middle but a little bit upper than baseline of text.
    margin-left: 5px;
    @include media(mobile, tablet) {
      width: auto;
      height: 16px;
    }
  }
  &__action {
    position: absolute;
    top: 0;
    right: 0;
    button {
      border: 1px solid $theme-color;
      color: $theme-color;
      @include darkBlue;
    }
    /deep/ .zm-icons {
      width: 12px;
      height: 12px;
      margin-left: 4px;
    }

    &-sub {
      text-align: right;
      margin-top: 19px;
      margin-right: 15px;
      button {
        border: none
      }
      .zm-button--link {
        color: #0B5CFF;
      }
    }
  }
  &__subtitle {
    font-weight: 500;
    font-size: 14px;
    line-height: 150%;
    color: #00053d;
    text-align: left;
    @include darkTextColor;
  }
  &__description {
    font-weight: 500;
    font-size: 14px;
    line-height: 150%;
    color: #515079;
    margin-top: 6px;
    @include darkTextColor2;
    @include media(mobile, tablet) {
      margin-top: 8px;
      font-weight: 400;
    }
    &-freetrial {
      margin-right: 150px;
      @include media(mobile) {
        margin-right: 0;
      }
    }
  }
  &.has-logo {
    .opc-addon__description {
      padding-left: $logo-width + $gap;
      @include media(mobile,tablet){
        padding-left: 0px;
      }
    }
  }
  &.opc-addon__free-trial {
    .opc-addon__subtitle {
      @include media(mobile, tablet) {
        margin-right: 30px;
      }
    }
  }
}

</style>
